import React, { useEffect, useState } from "react";
import { Button, Select, DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import VoyageDetails from "../../../../components/VoyageDetails";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import useUserData from "../../../../hooks/useUserData";
import SecurityCodeModal from "../../../../components/SecurityCodeModal";

const { Option } = Select;

function EditBunkerDelivery() {
  const { bunkerdelivery_id } = useParams();
  const navigate = useNavigate();
  const user = useUserData();
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [loader, set_loader] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [soft_delete, set_Soft_Dlt] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  const [form, setForm] = useState({
    bunkerRefNo: "",
    bunkerDate: moment().format("YYYY-MM-DD"),
    bdnRefNo: "",
    sampleOrigin: "",
    marpolSealNo: "",
    lopIssued: "",
    lopCopyTo: [],
    lopCopyOther: "",
    remarks: "",
    chiefEngSignDigital: "",
    dateSampleDestroyed: null,
    chiefEngSign: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    VIEW_BUNKER_DETAILS(parsedData);
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const UPDATE_BUNKER_DETAILS = (save_submit) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("request_type", "edit");
      formData.append("record_id", atob(bunkerdelivery_id));
      formData.append("save_submit", Number(save_submit) || 0);
      formData.append("voyage_id", staff_dashboard?.voyage_details[0]?.id);
      formData.append("bunker_date", form.bunkerDate || "");
      formData.append("bdn_ref_no", form.bdnRefNo || "");
      formData.append("sample_origin", form.sampleOrigin || "");
      formData.append("marpol_seal_no", form.marpolSealNo || "");
      formData.append("lop_issued", form.lopIssued || "");
      formData.append("lop_copy_to", form.lopCopyTo || "");
      formData.append("lop_copy_other", form.lopCopyOther || "");
      formData.append("remarks", form.remarks || "");
      formData.append("chief_eng_sign_digital", form.chiefEngSignDigital || "");
      if (form.dateSampleDestroyed && moment.isMoment(form.dateSampleDestroyed)) {
        formData.append(
          "date_sample_destroyed",
          form.dateSampleDestroyed.format("YYYY-MM-DD")
        );
      }
      formData.append("chief_eng_sign", form.chiefEngSign || "");

      post(ApiURL?.view_bunker_delivery_st_bdn, formData)
        .then((res) => {
          const responseData = res?.response?.data || res;
          if (responseData?.status === true) {
            SuccessToast(
              "Success message!",
              "Bunker delivery note updated successfully"
            );
            navigate("/list-bunker-delivery-note");
            set_loader(false);
          } else {
            let newErrors = responseData?.errors || {};
            if (responseData?.error && typeof responseData.error === "string") {
              if (responseData.error.toLowerCase().includes("date_sample_destroyed")) {
                newErrors.dateSampleDestroyed = responseData.error;
              }
              if (responseData.error.toLowerCase().includes("bunker_date")) {
                newErrors.bunkerDate = responseData.error;
              }
            }
            setErrors(newErrors);
            if (Object.keys(newErrors).length === 0) {
              ErrorToast("Error", responseData?.message || responseData?.error || "Check your details.");
            }
            set_loader(false);
          }
        })
        .catch((error) => {
          set_loader(false);
          ErrorToast("Error", "Server side error occurred.");
          console.error("Error while submitting bunker details:", error);
        });
    } catch (error) {
      set_loader(false);
      console.error("Unexpected error in handleSubmit:", error);
    }
  };

  const VIEW_BUNKER_DETAILS = async (voyage_data) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", voyage_data?.voyage_details?.[0]?.id);
    FORM_DATA.append("record_id", atob(bunkerdelivery_id));
    FORM_DATA.append("request_type", "view");
    try {
      const response = await post(
        ApiURL?.view_bunker_delivery_st_bdn,
        FORM_DATA
      );
      if (response?.status == true) {
        const data = response?.data;
        setSubmitStatus(data?.submit_status);
        setForm({
          bunkerRefNo: data?.bunker_ref_no || "",
          bunkerDate: data?.bunker_date || "",
          bdnRefNo: data?.bdn_ref_no || "",
          sampleOrigin: data?.sample_origin || "",
          marpolSealNo: data?.marpol_seal_no || "",
          lopIssued:
            data?.lop_issued === true
              ? "Yes"
              : data?.lop_issued === false
              ? "No"
              : "",
          lopCopyTo: data?.lop_copy_to ? [data.lop_copy_to] : [],
          lopCopyOther: data?.lop_copy_other || "",
          remarks: data?.remarks || "",
          chiefEngSignDigital: data?.chief_eng_sign_digital || "",
          dateSampleDestroyed: data?.date_sample_destroyed
            ? moment(data.date_sample_destroyed)
            : null,
          chiefEngSign: data?.chief_eng_sign || "",
        });
        set_Soft_Dlt(data?.soft_delete);
      } else {
        console.error("Failed to fetch bunker delivery details:", response);
      }
    } catch (error) {
      console.error("Error in VIEW_BUNKER_DETAILS_LIST:", error);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <h3>Edit Bunker Delivery Form</h3>
        <br />
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Bunker Ref. No"
              value={form.bunkerRefNo}
              onChange={(e) => handleChange("bunkerRefNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              type="date"
              label="Bunker Date"
              disabled={submitStatus}
              value={form.bunkerDate}
              onChange={(e) => handleChange("bunkerDate", e.target.value)}
              errors={errors.bunker_date || errors.bunkerDate}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="BDN Ref. No"
              value={form.bdnRefNo}
              onChange={(e) => handleChange("bdnRefNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>Sample Origin (Supplier/Ship)</label>
            <Select
              disabled={submitStatus}
              value={form.sampleOrigin}
              onChange={(value) => handleChange("sampleOrigin", value)}
              placeholder="Select origin"
              style={{ width: "100%" }}
            >
              <Option value="Supplier">Supplier</Option>
              <Option value="Ship">Ship</Option>
              <Option value="Both">Supplier & Ship both</Option>
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="MARPOL Sample Seal No."
              value={form.marpolSealNo}
              onChange={(e) => handleChange("marpolSealNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>LOP Issued</label>
            <Select
              disabled={submitStatus}
              value={form.lopIssued}
              onChange={(value) => handleChange("lopIssued", value)}
              placeholder="Select"
              style={{ width: "100%" }}
            >
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label>LOP Copy To</label>
            <Select
              disabled={submitStatus}
              value={form.lopCopyTo}
              onChange={(value) => handleChange("lopCopyTo", value)}
              placeholder="Select recipients"
              style={{ width: "100%" }}
            >
              <Option value="Supplier">Supplier</Option>
              <Option value="PSC">PSC</Option>
              <Option value="Vessel">Vessel</Option>
              <Option value="Flag">Flag</Option>
              <Option value="Others">Others</Option>
            </Select>
          </div>
          {form.lopCopyTo.includes("Others") && (
            <div className="col-6">
              <AppInput
                disabled={submitStatus}
                label="LOP Copy - Specify Others"
                value={form.lopCopyOther}
                onChange={(e) => handleChange("lopCopyOther", e.target.value)}
              />
            </div>
          )}
        </div>

        <div className="row ">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Remarks (if any)"
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Chief Eng. Name & Sign (Digital)"
              value={form.chiefEngSignDigital}
              onChange={(e) =>
                handleChange("chiefEngSignDigital", e.target.value)
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label>Date Sample Destroyed (if - 12 months)</label>
            <DatePicker
              disabled={submitStatus}
              style={{ width: "100%" }}
              type="date"
              value={form?.dateSampleDestroyed}
              onChange={(date) => handleChange("dateSampleDestroyed", date)}
            />
            {errors.date_sample_destroyed || errors.dateSampleDestroyed ? (
              <span style={{ color: "red" }}>
                {errors.date_sample_destroyed || errors.dateSampleDestroyed}
              </span>
            ) : null}
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Chief Eng. Name & Sign"
              value={form.chiefEngSign}
              onChange={(e) => handleChange("chiefEngSign", e.target.value)}
              errors={errors.chief_eng_sign || errors.chiefEngSign}
            />
          </div>
        </div>

        <div className="row">
          {soft_delete ||
            (user?.data?.designation === "Chief Engineer" &&
              bunkerdelivery_id && (
                <>
                  <div
                    className="input-box"
                    style={{ marginLeft: "15px", marginTop: "15px" }}
                  >
                    <Button
                      loading={loader}
                      disabled={submitStatus}
                      className="save_btn"
                      style={{ color: "white" }}
                      onClick={() => setModalVisible(true)}
                    >
                      Submit
                    </Button>
                  </div>
                </>
              ))}
        </div>
        <SecurityCodeModal
          record_id={atob(bunkerdelivery_id)}
          visible={modalVisible}
          setModalVisible={setModalVisible}
          onCancel={() => setModalVisible(false)}
          onSuccess={() => {
            UPDATE_BUNKER_DETAILS("1");
            setModalVisible(false);
          }}
          apiEndPoint={ApiURL.verify_security_code_st}
        />
      </div>
    </>
  );
}

export default EditBunkerDelivery;
